// extracted by mini-css-extract-plugin
module.exports = {"input":"TextInput_input__3TItM","errorLabel":"TextInput_errorLabel__31iP1"};